import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { LoginComponent } from './login/login.component';
import { authGuard } from './utils/guard/auth.guard';
import { grantResolver } from './resolvers/grant.resolver';
import { NxLicenseErrorPageComponent } from './shared/nx-license-error-page/nx-license-error-page.component';
import { PrivacyPolicyComponent } from './privacy-policy/privacy-policy.component';
import { ForgotPasswordComponent } from './password-reset/forgot-password.component';
import { ResetPasswordComponent } from './password-reset/reset-password.component';

const routes: Routes = [
  { path: '', redirectTo: '/main/home', pathMatch: 'full' },
  { path: 'login', component: LoginComponent },
  { path: 'password-dimenticata', component: ForgotPasswordComponent },
  { path: 'reset-password', component: ResetPasswordComponent },
  { path: 'license-inactive', component: NxLicenseErrorPageComponent, title: 'NES - Licenza' },
  { path: 'privacy-policy', component: PrivacyPolicyComponent },
  {
    path: 'main',
    loadChildren: () => import('./auth/nes.module').then(m => m.NESModule),
    canActivate: [authGuard],
    resolve: {
      grants: grantResolver,
    },
  },
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule],
})
export class AppRoutingModule {}
